$.fn.Balado = function() {
  let self = this

  if (self.data('balado')) {
    return self.data('balado')
  }

  self.audio_player = self.find('.audio-player').AudioPlayer()
  self.share_sheet = self.find('.audio-share')

  self.el = {
    play: self.find('.balado__play-btn'),
    pause: self.find('.balado__pause-btn'),
    total: self.find('.balado__total-time'),
    title: self.find('.balado__title'),
    content: self.find('.balado__content'),
  }

  self.title_clicked = function() {
    if (self.attr('aria-expanded') === 'false') {
      self.attr('aria-expanded', 'true')
      self.el.content.attr('aria-hidden', 'false')
    } else {
      self.attr('aria-expanded', 'false')
      self.el.content.attr('aria-hidden', 'true')
    }
  }

  self.resized = function() {
    let maxHeight = 0
    if ($.mlmi.mobile.isMobile) {
      maxHeight += self.find('.balado__description').outerHeight(false) + self.find('.balado__thumbnail').outerHeight(false)
    } else {
      maxHeight += Math.max(self.find('.balado__description').outerHeight(false), self.find('.balado__thumbnail').outerHeight(false))
    }
    self.el.content.css('max-height', maxHeight + 'px')
  }

  self.close_clicked = function() {
    self.audio_player.attr('aria-hidden', 'true')
    self.audio_player.pause()
  }

  self.share_clicked = function() {
    self.share_sheet.attr('aria-hidden', 'false')
    self.share_sheet.find('.audio-share__close-btn').on('click', function() {
      self.share_sheet.attr('aria-hidden', 'true')
    })
  }

  self.play_clicked = function(e) {
    e.preventDefault()
    $('.audio-player').removeClass('audio-player--playing').attr('aria-hidden', 'true')
    requestAnimationFrame(function() {
      self.audio_player.attr('aria-hidden', 'false')
      self.audio_player.play()
    })
  }

  self.pause_clicked = function(e) {
    e.preventDefault()
    self.audio_player.pause()
  }

  self.player_loaded = function() {
    self.el.total.text(self.audio_player.el.total.text())
  }

  self.player_played = function() {
    self.addClass('balado--playing')
  }

  self.player_paused = function() {
    self.removeClass('balado--playing')
  }

  return function() {
    self.el.play.on('click', self.play_clicked)
    self.el.pause.on('click', self.pause_clicked)
    if (self.el.content.length) {
      self.el.title.on('click', self.title_clicked)
      $(window).on('load resize orientationchange', self.resized)
      self.resized()
    }
    self.audio_player.on('play', self.player_played)
    self.audio_player.on('pause', self.player_paused)
    self.audio_player.on('loadedmetadata', self.player_loaded)
    self.audio_player.find('.audio-player__close-btn').on('click', self.close_clicked)
    self.audio_player.find('.audio-player__share-audio').on('click', self.share_clicked)
    $('body').append(self.audio_player.detach())
    $('body').append(self.share_sheet.detach())
    self.data('balado', self)
    return self
  }()
}
